import PageMeta from 'components/PageMeta'
import PageLayout from 'components/pages/PageLayout'
import { withApollo } from 'components/withApollo'
import { NextPage } from 'next'
import HeroSection from 'components/pages/ExperientialMarketingPage/HeroSection'
import AboutUsSection from 'components/pages/ExperientialMarketingPage/AboutUsSection'
import ClientCaseSection from 'components/pages/ExperientialMarketingPage//ClientCaseSection'
import ClientClouds from 'components/ClientClouds'
import ChatWidget from 'components/ChatWidget'

const ExperientialMarketingPage = () => {
  return (
    <>
      <ChatWidget />
      <PageLayout fullWidth gray staticPage>
        <PageMeta
          canonicalPath="/experiential-marketing"
          description="Experiential Marketing division specializes in immersing
            consumers through revolutionary branded mobile experiences that are
            creatively fun, interactive and maximize direct customer engagement"
          keywords="food trucks, experiential marketing"
          title="Best Food Trucks | Experiential Marketing"
        />
        <div className="w-full">
          <HeroSection />
          <ClientClouds
            clients={[
              'mcCormick',
              'spacex',
              'cbs',
              'brookfield',
              'pfizer',
              'swedish',
              'claremont'
            ]}
          />
          <AboutUsSection />
          <ClientCaseSection />
        </div>
      </PageLayout>
    </>
  )
}

const ExperientialMarketingPageWithApollo = withApollo({ ssr: false })(
  ExperientialMarketingPage as NextPage
)
export default ExperientialMarketingPageWithApollo
